<template>
    <div>
        <table class="matrix-table">
            <thead>
            <tr>
                <th width="50" v-for="x in widthRange">{{x}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="y in heightRange">
                <td v-for="x in widthRange">
                    {{matrix[(y*(width)) + (x)]}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<style lang="scss">
    .matrix-table {
        table-layout: fixed;
        width: 100%;
        text-align: center;
        font-size: 10px;
        th, td {
            &:nth-child(odd) {
                background-color: #e2e2e2
            }
            width: 20px;
        }
        th {
            font-weight: bold;
            background-color: red !important;
        }
    }
</style>

<script>
    export default {
        props: {
            matrix: {

            },
            width: {},
            height: {},
        },
        created() {

        },
        computed: {
            widthRange() {
                let range = [];
                for(let i = 0; i < this.width; i++) {
                    range.push(i)
                }
                return range
            },
            heightRange() {
                let range = [];
                for(let i = 0; i < this.height; i++) {
                    range.push(i)
                }
                return range
            },
        },
        data() {
            return {
                matrixEntries: []
            }
        }
    }
</script>